import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from 'features/common/components/Header';
import { EventTitleProps } from './types';

import { SubTitle, Title } from './EventTitle.styles';

// Delete Show is intentionally not offered from the standalone Edit Event header:
// deleting a Tixologi show is disabled across the panels to prevent accidental
// deletion when the organiser meant to hide it from the public instead.
const EventTitle: FC<EventTitleProps> = ({ title }: EventTitleProps) => {
	const { t } = useTranslation();

	return (
		<Header>
			<Title element="h2">{title}</Title>
			<SubTitle element="p">{t('editEvent-subtitle')}</SubTitle>
		</Header>
	);
};

const memorizedEventTitle: FC<EventTitleProps> = memo(EventTitle);

export { memorizedEventTitle as EventTitle };
